import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { BiSolidCheckSquare, BiSolidXSquare } from "react-icons/bi";

import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import { Viewer } from "@react-pdf-viewer/core";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";

const UserTodolistview = () => {
  const navigate = useNavigate();
  const { decryptData } = useEncryption();

  let { id } = useParams();
  console.log("🚀 ~ UserTodolistview ~ id:", id);

  const backButtonClick = () => {
    navigate("/todolist");
  };

  const [editData, setEditData] = useState({}); // Edit API Data set

  const getEditData = async () => {
    await axiosInstanceAuth
      .get(`viewsingletask/${id}`)
      .then((res) => {
        const myEditData = decryptData(res?.data?.data);
        setEditData(myEditData?.data);
        // console.log("first")
        console.log("Edit Data view user ID Wise --->", myEditData);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getEditData();
  }, []);

  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    if (editData?.attachment) {
      const url = `${BACKEND_BASE_URL}${editData?.attachment}`;
      setFileUrl(url);
    }
  }, [editData?.attachment]);

  const renderPdfViewer = () => {
    if (fileUrl) {
      return <Viewer fileUrl={fileUrl} workerSrc={pdfjsWorker} />;
    }

    return <div>No PDF available</div>;
  };

  return (
    <Layout>
      <div className="container">
        <div className="md:flex justify-between lg:my-10 my-3">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">View To-Do-List</h1>
          </div>
        </div>

        <div>
          <button
            onClick={backButtonClick}
            class="bg-[#22345C] gap-1  text-[#FFFFFF] font-sans text-lg font-bold py-1.5 px-2 rounded-[10px] inline-flex items-center"
          >
            <HiOutlineArrowNarrowLeft size={25} className="text-[#FFFFFF]" />
            <span>Back</span>
          </button>
        </div>

        <div>
          <div className="overflow-auto lg:overflow-visible mt-5">
            <table className="table w-full text-gray-400 border-separate space-y-6">
              <tbody>
                {/* <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <div>Nikhil</div>
                    <div className="text-gray-400 flex gap-2  text-justify">
                      <p>Description:-</p>
                      <p>Hello How Are You ... !</p>
                    </div>
                  </td>

                  <td className="p-1.5 ">
                        <div className="flex gap-1 items-center justify-center">
                          {d.status ? "Complete" : "Incomplete"}
                          <span>
                            {d.status ? (
                              <BiSolidCheckSquare
                                size={25}
                                className="text-[#5DC90A]"
                              />
                            ) : (
                              <BiSolidXSquare
                                size={25}
                                className="text-[#FF270E]"
                              />
                            )}
                          </span>
                        </div>
                      </td>

                  <td className="p-1.5 text-center">Vasu</td>
                  <td className="p-1.5 text-center">Admin</td>
                  <td className="p-1.5 text-center">22/10/2023</td>
                  <td className="p-1.5 text-center">23/10/2023</td>
                </tr> */}

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Task Title : </strong>
                    {editData?.name}
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Description : </strong>
                    {editData?.description}
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <div className="flex gap-1">
                      <strong>Status : </strong>{" "}
                      <span className="flex gap-1 items-center ">
                        {editData?.status ? "Complete" : "Incomplete"}
                        <span>
                          {editData?.status ? (
                            <BiSolidCheckSquare
                              size={25}
                              className="text-[#5DC90A]"
                            />
                          ) : (
                            <BiSolidXSquare
                              size={25}
                              className="text-[#FF270E]"
                            />
                          )}
                        </span>
                      </span>
                    </div>
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Assigned To : </strong>
                    {editData?.assignname}
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Role : </strong>
                    {editData?.role}
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Assigned Date : </strong>
                    {editData?.assigndate?.slice(0, 10)}
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Deadline : </strong>
                    {editData?.deadline?.slice(0, 10)}
                  </td>
                </tr>

                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Attachment : </strong>
                    {renderPdfViewer()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n\n    .table {\n    border-spacing: 0 15px;\n  }\n\n  i {\n    font-size: 1rem !important;\n  }\n\n  .table tr {\n    border-radius: 0px;\n  }\n\n  tr td:nth-child(n - 1),\n  tr th:nth-child(n - 1) {\n    border-radius: 0 0 0 0;\n  }\n\n  tr td:nth-child(1),\n  tr th:nth-child(1) {\n    border-radius: 10px;\n  }\n\n",
            }}
          />

          <link
            href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
            rel="stylesheet"
          />
        </div>
      </div>
    </Layout>
  );
};

export default UserTodolistview;
